import { Component, OnInit } from '@angular/core';
import { FormConfig, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormConfigUtilityService } from '../../services/filterByConfigMetatags/form-config-utility.service';

@Component({
    selector: 'app-form-individual-on-exchange-plan-enrollment-payment',
    templateUrl: './form-individual-on-exchange-plan-enrollment-payment.component.html',
    styleUrls: ['./form-individual-on-exchange-plan-enrollment-payment.component.scss'],
    standalone: false
})
export class FormIndividualOnExchangePlanEnrollmentPaymentComponent implements OnInit {

  formJson: DefaultFormConfig;

  constructor(
    private formConfigUtilityService: FormConfigUtilityService
  ) { }

  async ngOnInit(): Promise<void> {

    this.formJson = await this.formConfigUtilityService.getFormConfigFromMap('formIndividualOnExchangePlanEnrollmentPayment');

    /** Make sure that any existing custom configs are carried over */
    this.formJson.form.customConfigs = Object.assign({}, {
      // confirmationPageUrl: this.confirmationPageUrl,
    }, this.formJson.form.customConfigs);

  }
}
